const PARTNERSHIPS_EMAIL = 'partnerships@rhino.fi'
export const PARTNERSHIPS_MAILTO = `mailto:${PARTNERSHIPS_EMAIL}`

export const SUPPORT_EMAIL = 'support@rhino.fi'
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`

export const B2C_DEPRECATION_URL = 'https://rhino.fi/b2c-app-deprecation'

export const SHUTDOWN_NOTICE_LS_KEY = 'shutdown-notice-seen'
